import React, { useContext } from 'react';
import { Button } from '@wix/wix-base-ui';
import { AnimationCustomizeButtonProps } from '../types';
import { TranslationContext } from '../context/TranslationContext';
import styles from '../assets/styles.scss';

export const AnimationCustomizeButton: React.FC<
  AnimationCustomizeButtonProps
> = ({ trigger, onClick, isDisabled }) => {
  const { translate } = useContext(TranslationContext);

  return (
    <div className={styles.customizeButton}>
      <Button
        className="btn-md"
        onClick={() => onClick(trigger)}
        disabled={isDisabled}
        shouldTranslate={false}
      >
        {translate('customize_button')}
      </Button>
    </div>
  );
};
